// extracted by mini-css-extract-plugin
module.exports = {"error-content":"error-content_error-content__shQRs"};